import React from 'react';
import Loader from './loader';


class PropertyBookmarkButton extends React.Component{
    constructor(props){
        super(props);
        this.onBookmarkClicked = this.onBookmarkClicked.bind(this);
    }

    onBookmarkClicked(){     
        if(this.props.onBookmarkClicked){
            this.props.onBookmarkClicked(!this.props.isBookmarked);
        }
    }

    render(){
        //console.log('In button - render - isBookmarked: '+this.props.isBookmarked+', fromPropertyDetail: '+this.props.fromPropertyDetail);
        var bButton = null;

        if(this.props.fromPropertyDetail){

            if(this.props.isIBProcessing){
                bButton = (
                    <span className="input-group-addon js-close-input-search" style={{float: "left", padding: "0 0 0 7px", background: "transparent", verticalAlign: "middle"}}>
                        <Loader inline="true" width="25" height="25" />
                    </span>
                );
            }
            else{
                bButton = (
                    <div className="div_icon tour-fav-bookmark">
                        <div className={this.props.isBookmarked ? 'active' : ''}  title={this.props.isBookmarked ? 'Home is bookmarked' : 'Bookmark this Home'} onClick={this.onBookmarkClicked}>
                            <i className="fa icon-bookmark"></i>
                        </div>
                    </div>
                );
            }
        }
        else{
            if(this.props.isIBProcessing){
                bButton = (
                    <span className="input-group-addon js-close-input-search" style={{float: "left", padding: "0 0 0 7px", background: "transparent", verticalAlign: "middle"}}>
                        <Loader inline="true" width="18" height="18" />
                    </span>
                );
            }
            else{
                bButton = (
                    <div className={this.props.isBookmarked ? 'bookmark_icon active' : 'bookmark_icon'} title={this.props.isBookmarked ? 'Home is bookmarked' : 'Bookmark this Home'} onClick={this.onBookmarkClicked}>
                        <i className="fa icon-bookmark"></i>
                    </div>
                );
            }
        }

        return(
            <div style={{display: "inline-block", verticalAlign: "top"}}>
                {bButton}
            </div>
        );
    }
}

export default PropertyBookmarkButton;